// throwing an AuthenticationError will log the user out
// in the requestErrorHandlingMiddleware
export default class AuthenticationError extends Error {
  name = 'AuthenticationError';
}
